import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { pagesFromTotal } from 'shared/utils/pagination';

const state = createSelector(
  (state: RootState) => state.teams.teams,
  (state) => state,
);

export const selectLoading = createSelector([state], (state) => ({
  isLoading: state.isLoading,
  isLoaded: state.isLoaded,
}));

export const selectTournamentId = createSelector([state], (state) => state.tournamentId);

export const selectTeams = createSelector([state], (state) => (state.teams ? state.teams : []));

export const selectTeamsPagination = (perPage: number) =>
  createSelector([state], (state) => {
    const pages = Math.max(1, pagesFromTotal(state.teams.length, perPage || 1));
    return {
      pages,
      allItemsCount: state.teams.length,
      limit: state.limit,
      allDataLoaded: state.allDataLoaded,
    };
  });

export const selectError = createSelector([state], (state) => state.error);

export const selectFilter = createSelector([state], (state) => state.filter);

export const selectTeamsByFilter = createSelector([state], (state) => (Boolean(state.filter.text) ? state.filter.teams : state.teams));

export const selectTeamById = (teamId: number) =>
  createSelector([state], (state) => state.teams && state.teams.find((team) => team.id === teamId));
